<template>
    <DataTable :loading="!header" :value="dataArray" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table"
        :rowClass="hideRow">
        <Column field="RiskDesc" :header="$t('risk_des')" key="RiskDesc">
            <template #body="slotProps">
                <InputText name="RiskDesc" v-model="slotProps.data[slotProps.column.props.field]" type="text"
                    :placeholder="$t('risk_des')" :disabled="true" @change="onCellEditComplete(slotProps)" />
            </template>
        </Column>
        <Column field="Control" :header="$t('control')" key="Control">
            <template #body="slotProps">
                <InputText name="Control" v-model="slotProps.data[slotProps.column.props.field]" type="Control"
                    :placeholder="$t('control')" :disabled="mode != this.$FORM_MODE_CREATE &&
                        mode != this.$FORM_MODE_EDIT" @change="onCellEditComplete(slotProps)" />
            </template>
        </Column>
    </DataTable>
</template>
<script>
export default {
    props: {
        dataArray: {
            type: Array,
            default: []
        },
        dataModel: {
            type: Object,
            default: []
        },
        mode: {
            type: String,
            default: ""
        },
        header: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            companyCode: this.$store.getters.getCompanyCode,
            getLang: this.$store.getters.getLanguage,
        }
    },
    methods: {
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetail() {
            var newDetail = this.dataModel;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.dataArray.push(det);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.dataArray[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.dataArray.splice(this.dataArray.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {

            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.dataArray && this.dataArray.length > 0) {
                let m = this.dataArray[index].mode;

                if (m == this.$FORM_MODE_UNCHANGED) {
                    this.dataArray[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        changever(event, e) {
            if (this.dataArray && this.dataArray.length > 0) {
                this.dataArray[event.index].Version = e == null ? "1" : e.id;
            }
        }
    },
    computed: {
        canEdit() {
            return this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT;
        }
    }
}
</script>